<template>
  <a-modal
    :open="open"
    @cancel="handleClose"
    centered
    :width="700"
    :bodyStyle="{ height: 'max(65vh, 600px)' }"
    wrapClassName="onboarding-end-modal"
    :footer="false"
  >
    <div class="success">
      <div class="content">
        <h2>{{ title }}</h2>

        <h3 v-if="subtitle">{{ subtitle }}</h3>

        <p v-if="description">{{ description }}</p>

        <div class="actions">
          <a-button v-if="cancelText" ghost class="button" @click="handleCancel">
            {{ cancelText }}
          </a-button>

          <a-button v-if="okText" class="button" type="primary" @click="handleContinue">
            {{ okText }}
          </a-button>
        </div>
      </div>

      <img class="background-img" :src="successBackgroundImage" alt="success" />
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import successBackgroundImage from "@/app/channels/assets/success.webp";

defineProps<{
  open: boolean;
  title: string;
  subtitle?: string;
  description?: string;
  okText?: string;
  cancelText?: string;
}>();

const emit = defineEmits<{
  "update:open": [open: boolean];
  ok: [];
  cancel: [];
  closeModal: [open: boolean];
}>();

const handleClose = () => {
  emit("update:open", false);
  emit("closeModal", false);
};

const handleContinue = () => {
  emit("ok");
  handleClose();
  emit("closeModal", false);
};

const handleCancel = () => {
  emit("cancel");
  handleClose();
};
</script>

<style scoped lang="sass">
:global(.onboarding-end-modal .ant-modal-close)
  color: white

.success
  background-color: #001529
  position: absolute
  inset: 0
  padding: 54px 48px
  border-radius: 8px
  height: 100%
  width: 100%
  overflow: hidden

.background-img
  position: absolute
  bottom: 0
  left: 0
  right: 0
  width: 100%

.button
  position: relative
  z-index: 90

.content
  color: $gray-2
  text-align: center

  h2
    font-size: 38px
    font-weight: 600
    line-height: 46px
    margin-bottom: 5px
    text-wrap: balance

  h3
    font-size: 20px
    line-height: 28px
    font-weight: 600
    margin-bottom: 16px
    color: $gray-3
    text-wrap: balance

  p
    font-size: 16px
    line-height: 24px
    margin-bottom: 28px
    margin-top: 16px
    text-wrap: balance

.actions
  display: flex
  gap: 8px
  justify-content: center
</style>
